// 注：apiRuledesign使用了apiBaseUrl的api域名，需手动加“ruledesign”前缀去调规则设计器的api
import { apiBaseUrl, apiOpcs } from 'yxt-biz-pc/packages/api';

/**
 * 获取关联的规则对象列表
 * @param {*} params 数据查询参数(业务注册数据)
 * @param {*} type 平台类型：op-运营平台
 * @returns
 */
export const getRelatedObjList = (params, type) => {
  if (type === 'op') {
    // 运营平台
    return apiOpcs.get('op/rule/admin/dict/associate/target/list', { params });
  }
  // 学习平台
  return apiBaseUrl.get(`ruledesign/rule/target/${params.businessCode}/${params.moduleCode}`);
};

/**
 * 获取关联的规则动作列表
 * @param {*} associateId 关联关系ID
 * @param {*} type 平台类型：op-运营平台
 * @returns
 */
export const getRelatedActionList = (associateId, type) => {
  if (type === 'op') {
    return apiOpcs.get('op/rule/admin/dict/associate/action/list', { params: { associateId } });
  }
  return apiBaseUrl.get(`ruledesign/rule/action/${associateId}`);
};

/**
 * 获取关联的规则属性列表
 * @param {*} associateId 关联关系ID
 * @param {*} type 平台类型：op-运营平台
 * @returns
 */
export const getRelatedAttrList = (associateId, type) => {
  if (type === 'op') {
    return apiOpcs.get('op/rule/admin/dict/associate/attr/list', { params: { associateId } });
  }
  return apiBaseUrl.get(`ruledesign/rule/attr/${associateId}`);
};

/**
 * 获取规则信息
 * @param {*} ruleCode 规则编号
 * @param {*} type 平台类型：op-运营平台
 * @returns
 */
export const getRuleInfo = (ruleCode, type) => {
  if (type === 'op') {
    return apiOpcs.get(`op/rule/detail/${ruleCode}`);
  }
  return apiBaseUrl.get(`ruledesign/rule/detail/${ruleCode}`);
};

/**
 * 校验自定义规则表达式正确性
 * @param {*} params { expression-规则表达式，maxSort-同级属性/条件数量 } 注：该接口path参数只能通过拼接处理
 * @param {*} type 平台类型：op-运营平台
 * @returns
 */
export const checkExpression = (data, type) => {
  if (type === 'op') {
    return apiOpcs.post('op/rule/check/expression', data);
  }
  return apiBaseUrl.post('ruledesign/rule/check/expression', data);
};

